import { getOptimizedCDNUrl } from "@/utils/cdn.utils";

/**
 * Get the full CDN URL for an image with optimization params.
 * Delegates to cdn.utils for network-aware optimization.
 *
 * @param {string} imageName - The image filename or path
 * @param {Object} [options] - CDN options (auto, hint, width, quality, format)
 * @returns {string|null} Full CDN URL or null
 */
export const getCMSImageURL = (imageName, options = {}) => {
  if (!imageName) return null;
  return getOptimizedCDNUrl(imageName, options);
};
